export const PlayerSizeConst = ({
    Large: {
        id: 3,
        label: 'Large',
        exist: false
    },
    Medium: {
        id: 2,
        label: 'Medium',
        exist: false
    },
    Small: {
        id: 1,
        label: 'Small',
        exist: false
    },
    Unknown: {
        id: 0,
        label: 'Unknown',
        exist: false
    },
    Vertical: {
        id: 5,
        label: 'Vertical',
        exist: false
    }
});
